import React from "react";
import { skills } from "../../data/portfolio";

const Tools = () => {
  return (
    <div className="skill-tags" aria-label="Detailed skills">
      {skills.map((skill) => (
        <span className="scroll-reveal" key={skill}>{skill}</span>
      ))}
    </div>
  );
};

export default Tools;
